<template>
    <div>
        <div ref="content" class="cursor-pointer" @mouseover="mouseOver" @mouseleave="mouseLeave" @click="click">
            <slot name="content" />
        </div>
        <div ref="tooltip" v-if="show" class="tooltip" @click="click">
            <slot name="tooltip" />
        </div>
    </div>
</template>

<script>
import { createPopper } from '@popperjs/core';
import { mapGetters } from 'vuex';

export default {
    name: 'Tooltip',

    props: {
        placement: {
            type: String,
            default: 'bottom',
        },
        withHover: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            show: false,
            popper: null,
        };
    },
    watch: {
        show() {
            if (this.show) {
                this.$nextTick(() => {
                    const content = this.$refs.content;
                    const tooltip = this.$refs.tooltip;
                    this.popper = createPopper(content, tooltip, {
                        placement: this.isMobile ? 'auto' : this.placement,
                        strategy: 'absolute',
                        modifiers: [
                            {
                                name: 'flip',
                                options: {
                                    fallbackPlacements: ['top', 'right', 'left'],
                                },
                            },
                        ].filter((v) => v),
                    });
                });
            } else {
                if (this.popper) {
                    this.popper.destroy();
                }
            }
        },
    },
    computed: {
        ...mapGetters(['isMobile']),
    },
    methods: {
        click() {
            this.$emit('click');
            this.show = !this.show;
        },

        mouseOver() {
            if (this.withHover) {
                this.show = true;
            }
        },
        mouseLeave() {
            if (this.withHover) {
                this.show = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';

.tooltip {
    box-shadow: 0 0 20px 0 rgba(70, 99, 171, 0.2);
    padding: urem(14) urem(22);
    border-radius: urem(10);
    background: #fff;
    width: max-content;
    @include set-font-size(14, 500, 22);
    z-index: 1000;
}
</style>
